export const DocumentValidation = (formData) => {
  const errors = {};

  // Validate each field

  if (!formData.DocumentName.toString().trim()) {
    errors.DocumentName = 'This field is required';
  }
  if (!formData.File && formData.ID === 0) {
    errors.Path = "Please attach a file before saving.";
  }

  return errors;
};

